import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function onDemandLearningFeaturedBlock() {
	const blocks = document.querySelectorAll('[data-js="on-demand-learning-featured"]');
	if (!blocks.length) return;

	blocks.forEach((block) => {
		const swipers = block.querySelectorAll('[data-js="odl-speakers-swiper"]');
		if (!swipers.length) return;

		swipers.forEach((el) => {
			if (el.swiper) return;

			const wrapper = el.closest('.media') || el.parentElement;
			const prevEl = wrapper?.querySelector('[data-js="odl-speakers-prev"]');
			const nextEl = wrapper?.querySelector('[data-js="odl-speakers-next"]');
			const paginationEl = wrapper?.querySelector('[data-js="odl-speakers-pagination"]');
			const totalSlides = Number(el.dataset.slides || 1);
			const hasManySlides = totalSlides > 1;

			new Swiper(el, {
				modules: [Navigation, Pagination],
				slidesPerView: 1,
				spaceBetween: 0,
				loop: hasManySlides,
				speed: 450,
				watchOverflow: true,
				allowTouchMove: hasManySlides,
				navigation: {
					prevEl: hasManySlides ? prevEl : null,
					nextEl: hasManySlides ? nextEl : null,
				},
				pagination: {
					el: hasManySlides ? paginationEl : null,
					clickable: true,
					bulletClass: 'odl-bullet',
					bulletActiveClass: 'is-active',
					renderBullet: (index, className) => `<span class="${className}" aria-label="Speaker ${index + 1}"></span>`,
				},
			});
		});
	});
}
